module.exports = __webpack_public_path__ + "img/sky-logo.d0eea702.png";